import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Select2OptionData } from 'ng-select2';
import { DeviceMakeViewModel } from '../../models/device-make-view-model';
import { DeviceModelViewModel } from '../../models/device-model-view-model';
import { TerminalConfigService } from '../../services/terminal-config.service';
import { CommsProfileService } from '../../services/comms-profile.service';
import { ProductProfileService } from '../../services/product-profile.service';
import { TerminalCapabilityService } from '../../services/terminal-capability.service';
import { Router } from '@angular/router';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { AuthenticationService } from '../../services/authentication.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TerminalService } from '../../services/terminal.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CardAcceptorConfigService } from '../../services/card-acceptor-config.service';
import { MerchantService } from '../../services/merchant.service';
import { HttpClient } from '@angular/common/http';
import { ParticipantService } from '../../services/participant.service';
import { ToastrService } from 'ngx-toastr';
import { PermissionEnum } from '../../services/guards/permissions';
import { AddUpdateTerminalInteractionViewModel } from '../../models/add-update-terminal-interaction-view-model';
import { MerchantSignUpViewModel } from '../../models/merchant-sign-up-view-model';
import { MerchantTerminalConfigViewModel } from '../../models/merchant-terminal-config-view-model';
import { AddUpdateTerminalSignUpViewModel } from '../../models/add-update-terminal-sign-up-view-model';
import { NgSelectComponent } from '@ng-select/ng-select';
import { MerchantDTViewModel } from '../../models/merchant-dt-view-model';
import { TerminalViewModel } from '../../models/terminal-view-model';
import { TerminalContactsViewModel } from '../../models/terminal-contacts-view-model';
import { ConfirmationDialogComponent } from '../../partials/confirmation-dialog/confirmation-dialog.component';
import { CreateResult } from '../../models/create-result';
import { TerminalSignUpNotesViewModel } from '../../models/terminal-sign-up-notes';
import { DecodedNameLocation } from '../../models/decoded-name-location -view-model';
import { TmCardAcceptorConfigViewModel } from '../../models/tm-card-acceptor-model';

@Component({
  selector: 'app-terminal-sign-up',
  templateUrl: './terminal-sign-up.component.html',
  styleUrls: ['./terminal-sign-up.component.scss']
})
export class TerminalSignUpComponent implements OnInit {
  @ViewChild('merchantSelect') merchantSelect: NgSelectComponent;
  @ViewChild('terminalSelect') terminalSelect: NgSelectComponent;

  public TerminalFormGroup: FormGroup;
  areaBuffer = [];
  bufferSize = 50;
  numberOfItemsFromEndBeforeFetchingMore = 10;
  loading = false;
  public areaData = [];
  public select2options: any = {
    multiple: false,
    width: '100%',
    allowClear: true
  };
  public deviceMakeList: Select2OptionData[] = [];
  public deviceModelList: Select2OptionData[] = [];
  public terminalMakeList: DeviceMakeViewModel[];
  public terminalModelList: DeviceModelViewModel[];
  public terminalSignUpNote: TerminalSignUpNotesViewModel;
  public terminalSignUpNotes: TerminalSignUpNotesViewModel[] = [];
  public parameterDownloadInteractionDays: Select2OptionData[] = [
    { id: "1", text: 'Sunday' },
    { id: "2", text: 'Monday' },
    { id: "4", text: 'Tuesday' },
    { id: "8", text: 'Wednesday' },
    { id: "15", text: 'Thursday' }
  ];
  public terminalInteractionBankingWindowTimes: Select2OptionData[] = [
    { id: "", text: "" },
    { id: "00:00 - 00:30", text: "00:00 - 00:30" },
    { id: "00:30 - 01:00", text: "00:30 - 01:00" },
    { id: "01:00 - 01:30", text: "01:00 - 01:30" },
    { id: "01:30 - 02:00", text: "01:30 - 02:00" },
    { id: "02:00 - 02:30", text: "02:00 - 02:30" },
    { id: "02:30 - 03:00", text: "02:30 - 03:00" },
    { id: "03:00 - 03:30", text: "03:00 - 03:30" },
    { id: "03:30 - 04:00", text: "03:30 - 04:00" },
    { id: "04:00 - 04:30", text: "04:00 - 04:30" },
    { id: "04:30 - 05:00", text: "04:30 - 05:00" },
    { id: "05:00 - 05:30", text: "05:00 - 05:30" },
    { id: "05:30 - 06:00", text: "05:30 - 06:00" },
    { id: "06:00 - 06:30", text: "06:00 - 06:30" },
    { id: "06:30 - 07:00", text: "06:30 - 07:00" },
    { id: "07:00 - 07:30", text: "07:00 - 07:30" },
    { id: "07:30 - 08:00", text: "07:30 - 08:00" },
    { id: "08:00 - 08:30", text: "08:00 - 08:30" },
    { id: "08:30 - 09:00", text: "08:30 - 09:00" },
    { id: "09:00 - 09:30", text: "09:00 - 09:30" },
    { id: "09:30 - 10:00", text: "09:30 - 10:00" },
    { id: "10:00 - 10:30", text: "10:00 - 10:30" },
    { id: "10:30 - 11:00", text: "10:30 - 11:00" },
    { id: "11:00 - 11:30", text: "11:00 - 11:30" },
    { id: "11:30 - 12:00", text: "11:30 - 12:00" },
    { id: "12:00 - 12:30", text: "12:00 - 12:30" },
    { id: "12:30 - 13:00", text: "12:30 - 13:00" },
    { id: "13:00 - 13:30", text: "13:00 - 13:30" },
    { id: "13:30 - 14:00", text: "13:30 - 14:00" },
    { id: "14:00 - 14:30", text: "14:00 - 14:30" },
    { id: "14:30 - 15:00", text: "14:30 - 15:00" },
    { id: "15:00 - 15:30", text: "15:00 - 15:30" },
    { id: "15:30 - 16:00", text: "15:30 - 16:00" },
    { id: "16:00 - 16:30", text: "16:00 - 16:30" },
    { id: "16:30 - 17:00", text: "16:30 - 17:00" },
    { id: "17:00 - 17:30", text: "17:00 - 17:30" },
    { id: "17:30 - 18:00", text: "17:30 - 18:00" },
    { id: "18:00 - 18:30", text: "18:00 - 18:30" },
    { id: "18:30 - 19:00", text: "18:30 - 19:00" },
    { id: "19:00 - 19:30", text: "19:00 - 19:30" },
    { id: "19:30 - 20:00", text: "19:30 - 20:00" },
    { id: "20:00 - 20:30", text: "20:00 - 20:30" },
    { id: "20:30 - 21:00", text: "20:30 - 21:00" },
    { id: "21:00 - 21:30", text: "21:00 - 21:30" },
    { id: "21:30 - 22:00", text: "21:30 - 22:00" },
    { id: "22:00 - 22:30", text: "22:00 - 22:30" },
    { id: "22:30 - 23:00", text: "22:30 - 23:00" },
    { id: "23:00 - 23:30", text: "23:00 - 23:30" }
  ];
  public terminalInteractionParameterTimes: Select2OptionData[] = [
    { id: "23:00 - 23:30", text: "23:00 - 23:30" },
    { id: "23:30 - 00:00", text: "23:30 - 00:00" },
    { id: "00:00 - 00:30", text: "00:00 - 00:30" },
    { id: "00:30 - 01:00", text: "00:30 - 01:00" },
    { id: "01:00 - 01:30", text: "01:00 - 01:30" },
    { id: "01:30 - 02:00", text: "01:30 - 02:00" },
    { id: "02:00 - 02:30", text: "02:00 - 02:30" },
    { id: "02:30 - 03:00", text: "02:30 - 03:00" },
    { id: "03:00 - 03:30", text: "03:00 - 03:30" },
    { id: "03:30 - 04:00", text: "03:30 - 04:00" },
    { id: "04:00 - 04:30", text: "04:00 - 04:30" },
    { id: "04:30 - 05:00", text: "04:30 - 05:00" },
    { id: "05:00 - 05:30", text: "05:00 - 05:30" },
    { id: "05:30 - 06:00", text: "05:30 - 06:00" },
    { id: "06:00 - 06:30", text: "06:00 - 06:30" },
    { id: "06:30 - 07:00", text: "06:30 - 07:00" },
    { id: "07:00 - 07:30", text: "07:00 - 07:30" }
  ];

  public terminalDeliveryMethod: Select2OptionData[] = [
    { id: "Courier", text: 'Courier' },
    { id: "Collection", text: 'Collection' },
    { id: "Field Services", text: 'Field Services' }
  ];

  public tmCardAcceptor: TmCardAcceptorConfigViewModel;
  public submitted: boolean;
  public regions: Select2OptionData[];
  public countries: Select2OptionData[];
  public manualPanEntry: boolean;
  terminalCount: number;
  public bankingWindowUpdate: AddUpdateTerminalInteractionViewModel;
  public parameterDownloadWindowUpdate: AddUpdateTerminalInteractionViewModel;
  public bankingParamDownlWindowUpdateAll: AddUpdateTerminalInteractionViewModel[];
  public merchantSignUpDetails: MerchantSignUpViewModel;
  public defaultCardSet: string;
  public defaultTerminalConfig: number;
  public defaultTerminalType: number;
  public defaultTerminalCapability: number;
  public defaultTerminalProductProfile: number;
  public defaultTerminalCommsProfile: number;
  public terminalId: string;
  public deviceMake: string;
  public deviceModel: string;
  public merchantTerminalDefaultConfig: MerchantTerminalConfigViewModel;
  public raiseDanger: boolean = false;
  public raiseWarning: boolean = false;
  public success: boolean = false;
  public message: string;
  public danger: string;
  public warning: string;
  public contactPostalServiceCodeFC: FormControl;
  public cityFC: FormControl;
  public selectedArea: string = '';
  public deviceList: AddUpdateTerminalSignUpViewModel[] = [];
  public devices = [];
  public deviceContactList = [];
  public merchants: MerchantDTViewModel[];
  public terminals: TerminalViewModel[];
  public selectedMerchant: string;
  public selectedTerminal: string;
  public selectedCity: string = '';
  public TerminalContacts: TerminalContactsViewModel[] = [];
  public createResult: CreateResult;
  constructor(private _terminalConfigService: TerminalConfigService,
    private _commsProfileService: CommsProfileService,
    private _productProfileService: ProductProfileService,
    private _terminalCapabilityService: TerminalCapabilityService,
    private _router: Router,
    private _userDataStore: UserDataStoreService,
    private _authenticationService: AuthenticationService,
    private _modalService: NgbModal,
    private _terminalService: TerminalService,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _toastService: ToastrService,
    private _formBuilder: FormBuilder,
    private _cardAcceptorConfigService: CardAcceptorConfigService,
    private _merchantService: MerchantService,
    private _http: HttpClient,
    private _participantService: ParticipantService, private cdr: ChangeDetectorRef) {

    this.setupTerminalFormControl();
  }

  public async initMerchants(): Promise<void> {

    this.merchants = await this._merchantService.GetAllMerchants();

  }

  public async getTerminals(merchantNr: any) {
    
    if (merchantNr !== 0) {
      this._ngxUiLoaderService.start();

      this.selectedMerchant = merchantNr;
      
      let signUp1 = {} as TerminalViewModel[];
      signUp1 = await this._terminalService.GetTerminalsAllByMerchantId(this.selectedMerchant);

      this.TerminalFormGroup.controls['terminalId'].setValue('');
      this.terminals = signUp1;// await this._terminalService.GetAllTerminals();// (this.selectedMerchant);

      this._ngxUiLoaderService.stop();

    }

  }

  async ngOnInit() {

    this._ngxUiLoaderService.start();

    this.getCodes();

    this.manualPanEntry = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddManualPanEntry, PermissionEnum.EditManualPanEntry, PermissionEnum.ViewManualPanEntry], []);

    this.terminalMakeList = await this._terminalService.GetDeviceMakes();

    this.deviceMakeList = (this.terminalMakeList).map((x) => {
      return { id: x.id.toString(), text: x.make }
    });

    this.terminalModelList = await this._terminalService.GetDeviceModels();

    this.deviceModelList = (this.terminalModelList).map((x) => {
      return { id: x.id.toString(), text: x.model }
    });

    this.countries = (await this._merchantService.GetCountries()).map((x) => {
      return { id: x.countryCode, text: x.country }
    });

    this.regions = (await this._merchantService.GetRegions()).map((x) => {
      return { id: x.regionCode, text: x.regionName }
    });

    this.setupDefaults();
    this.setupTerminalFormControl();

    this.TerminalFormGroup.controls["countryFC"].setValue('ZA');

    this.initMerchants();

    this._ngxUiLoaderService.stop();
  }

  async setupDefaults() {
    this.merchantTerminalDefaultConfig = await this._terminalConfigService.GetDefaultConfigByParticipantId(this._userDataStore.selectedParticipant.id);
    if (this.merchantTerminalDefaultConfig == null || this.merchantTerminalDefaultConfig == undefined) {
      this.raiseDanger = true;
      this.danger = "There is no default terminal config for this participant. Contact system administrator.";

      this.disableFields();
    }
    else {
      this.defaultCardSet = this.merchantTerminalDefaultConfig.cardSet;
      this.defaultTerminalConfig = this.merchantTerminalDefaultConfig.terminalConfig;
      this.defaultTerminalType = this.merchantTerminalDefaultConfig.terminalType;
      this.defaultTerminalCapability = this.merchantTerminalDefaultConfig.terminalCapabilities;
      this.defaultTerminalProductProfile = this.merchantTerminalDefaultConfig.productProfile;
      this.defaultTerminalCommsProfile = this.merchantTerminalDefaultConfig.commsProfile;
    }
  }

  public getCodes() {

    this._http.get("assets/data/areas.json").subscribe((data: any[]) => {

      this.areaData = data;
      this.areaBuffer = this.areaData.slice(0, this.bufferSize);
    });
  }
   
  onCitySelected(cityValue) {
    if (cityValue == null || cityValue == '') {
      } else {
      if (typeof cityValue != "string" && cityValue['Area'] != null) {
        this.selectedCity = cityValue['Area'];

        this.TerminalFormGroup.controls['cityFC'].setValue(cityValue['Area']);
        this.TerminalFormGroup.controls['contactPostalServiceCodeFC'].setValue(cityValue['StrCode']);
      } else if (typeof cityValue != "string") {
        this.selectedCity = cityValue['Area'];

        this.TerminalFormGroup.controls['cityFC'].setValue(cityValue['Area']);
        this.TerminalFormGroup.controls['contactPostalServiceCodeFC'].setValue(cityValue['BoxCode']);
      }
    }
  }

  setupTerminalFormControl() {

    this.TerminalFormGroup = this._formBuilder.group({
      merchantId: new FormControl('', Validators.compose([Validators.required])),
      terminalId: new FormControl('', Validators.compose([Validators.required,Validators.pattern('^[a-zA-Z0-9]+$')])),
      deviceMake: new FormControl('', Validators.compose([Validators.required])),
      deviceModel: new FormControl('', Validators.compose([Validators.required])),
      terminaldeliveryFC: new FormControl('', Validators.compose([Validators.required])),
      terminalNumber: new FormControl(this.terminalCount),
      terminalType: new FormControl(this.defaultTerminalType),
      productProfile: new FormControl(this.defaultTerminalProductProfile),
      terminalCapabilities: new FormControl(this.defaultTerminalCapability),
      commsProfile: new FormControl(this.defaultTerminalCommsProfile),
      isTerminalActive: new FormControl(true),
      sameAsMerchantAddress: new FormControl(false),
      isManualPan: new FormControl(''),
      isContactless: new FormControl(''),
      bankingWindowTimeFC: new FormControl(''),
      parameterDownloadDayFC: new FormControl(''),
      parameterDownloadWindowTimeFC: new FormControl(''),
      contactNameSurnameFC: new FormControl('', Validators.compose([Validators.required])),
      contactEmailAddressFC: new FormControl('', Validators.compose([Validators.required])),
      contactNameCellNrFC: new FormControl('', Validators.compose([Validators.required])),
      contactAddressFC: new FormControl('', Validators.compose([Validators.required])),
      contactRegionFC: new FormControl('', Validators.compose([Validators.required])),
      cityFC: new FormControl('', Validators.compose([Validators.required])),
      contactPostalServiceCodeFC: new FormControl('', Validators.compose([Validators.required])),
      countryFC: new FormControl('', Validators.compose([Validators.required])),
      bulkOrder: new FormControl(false),
      notesFC: new FormControl('')
    });

    
  }

  disableFields() {

    this.TerminalFormGroup.controls["terminalId"].disable();
    this.TerminalFormGroup.controls["deviceMake"].disable();
    this.TerminalFormGroup.controls["deviceModel"].disable();
    this.TerminalFormGroup.controls["bankingWindowTimeFC"].disable();
    this.TerminalFormGroup.controls["parameterDownloadDayFC"].disable();
    this.TerminalFormGroup.controls["parameterDownloadWindowTimeFC"].disable();
    this.TerminalFormGroup.controls["terminaldeliveryFC"].disable();
    this.TerminalFormGroup.controls["isManualPan"].disable();
    this.TerminalFormGroup.controls["isContactless"].disable();
    this.TerminalFormGroup.controls["isTerminalActive"].disable();
    this.TerminalFormGroup.controls["sameAsMerchantAddress"].disable();
    this.TerminalFormGroup.controls["commsProfile"].disable();
    this.TerminalFormGroup.controls["ContactNameSurnameFC"].disable();
    this.TerminalFormGroup.controls["ContactEmailAddressFC"].disable();
    this.TerminalFormGroup.controls["ContactNameCellNrFC"].disable();
    this.TerminalFormGroup.controls["ContactAddressFC"].disable();
    this.TerminalFormGroup.controls["ContactRegionFC"].disable();
    this.TerminalFormGroup.controls["ContactCityFC"].disable();
    this.TerminalFormGroup.controls["ContactPostalServiceCodeFC"].disable();
    this.TerminalFormGroup.controls["bulkOrder"].disable();

  }

  updateDelivery(event) {

  }

  async addTerminals() {
    
    this.submitted = true;
    this.raiseDanger = false;
    if (!this.TerminalFormGroup.valid) {
      this.raiseDanger = true;
      this.danger = "Please note that all fields are mandatory.";
      return;
    }
    this._ngxUiLoaderService.start();
    let signUp = await this.configureTerminalSignUp();
    if (signUp != null) {
      this.deviceList.push(signUp);

      let terminalContact = this.configureTerminalContacts();
      this.TerminalContacts.push(terminalContact);
      if (!signUp.bulkOrder) {
        this.terminals = null;
      }
      this.submitted = false;

    }

    await this.getTerminals(this.TerminalFormGroup.controls['merchantId'].value);

    this._ngxUiLoaderService.stop();
  }

  async save() {

    this.createResult = await this._terminalService.AddMutlipleDevicesRequests(this.deviceList);
    if (this.createResult.success) {
      this._toastService.success(this.createResult.message, "Success");

      await this.ContactInformation();

      await this.SaveNote();

      await this.SendNotification();

      this._router.navigate(['management', 'terminal-staging', '']);

    } else {
      this._toastService.error(this.createResult.message, "Error");
      this.raiseDanger = true;
      this.danger = this.createResult.message;
      return;
    }   
  }

  async SaveNote() {
    
    if ((this.TerminalFormGroup.controls['notesFC'].value) != '') {

      this.deviceList.forEach((terminal) => {

        this.terminalSignUpNote = {
          merchantNumber: terminal.merchantNumber,
          terminalId: terminal.terminalId,
          notes: this.TerminalFormGroup.controls['notesFC'].value,
          changedBy: '',
          changedOn: new Date,
          source: '',
          id: 0,
          userId: ''
        };

        this.terminalSignUpNotes.push(this.terminalSignUpNote)

      });

      if (this.terminalSignUpNotes.length > 0) {
        this.createResult = await this._terminalService.AddTerminalSignUpNote(this.terminalSignUpNotes);
      }
    }

  }

  async ContactInformation() {

    //this.configureTerminalContacts();

    this.createResult = await this._terminalService.AddTerminalContacts(this.TerminalContacts);

    if (this.createResult.message != null) {
      if (this.createResult.success) {
        this._toastService.success(this.createResult.message, "Success");

      } else {
        this._toastService.error(this.createResult.message, "Error");
        this.raiseDanger = true;
        this.danger = this.createResult.message;
      }
    }
  }

  async SendNotification() {
    
    this.createResult = await this._terminalService.SendNotification(this.deviceList, "terminal");
    if (this.createResult.success) {
      this._toastService.success(this.createResult.message, "Success");

    } else {
      this._toastService.error(this.createResult.message, "Error");
      this.raiseDanger = true;
      this.danger = this.createResult.message;
    }
  }

  async saveAllTerminals() {

   
  }

  viewContacts(terminalId: string) {
    
    var contact = this.TerminalContacts.find(x => x.terminalId == terminalId);

    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = false;
    dialogRef.componentInstance.acceptButtonText = "Close";
    dialogRef.componentInstance.title = "Terminal contact details";

    var str = [];
    str.push("Name & Surname: " + contact.nameSurname);
    str.push("Cell number: " + contact.cell);
    str.push("Email address: " + contact.email);
    str.push("Delivery address: " + contact.address);
    str.push("Region: " + contact.region);
    str.push("City: " + contact.city);
    str.push("Postal Service Code: " + contact.postalcode);
    str.push("Country: " + contact.country);
    dialogRef.componentInstance.listMessage = str;

  }

  async delete(terminalId: string) {

    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = "Yes";
    dialogRef.componentInstance.cancelButtonText = "No"
    dialogRef.componentInstance.title = "Remove a terminal"
    dialogRef.componentInstance.message = "Are you sure you want to delete the selected record?"

    const result = await dialogRef.result;
    if (result) {
      await this.deleteRecord(terminalId);
    }
  }

  public async deleteRecord(terminalId: string): Promise<void> {
    const index = this.deviceList.findIndex(x => x.terminalId == terminalId);
    if (index > -1) {
      this.deviceList.splice(index, 1);
    }

    if (this.deviceList.length == 0) {
      //disable contact fields
      this.TerminalFormGroup.controls['contactAddressFC'].enable();
      this.TerminalFormGroup.controls['contactAddressFC'].enable();
      this.TerminalFormGroup.controls['contactRegionFC'].enable();
      this.TerminalFormGroup.controls['cityFC'].enable();
      this.TerminalFormGroup.controls['contactPostalServiceCodeFC'].enable();
      this.TerminalFormGroup.controls['contactNameCellNrFC'].enable();
      this.TerminalFormGroup.controls['contactEmailAddressFC'].enable();
      this.TerminalFormGroup.controls['merchantId'].enable();
      this.TerminalFormGroup.controls['contactNameSurnameFC'].disable();
      this.TerminalFormGroup.controls["countryFC"].enable();
    }
  }
  
  configureTerminalContacts() {
    
    let teminalContact = {} as TerminalContactsViewModel;
    var isBulkActive = false;
    var deviceContact: TerminalContactsViewModel = null;
    if (this.TerminalContacts.length > 0 && this.deviceList.length > 0) {
      deviceContact = this.TerminalContacts[0];
      isBulkActive = this.deviceList[0].bulkOrder;
    }

    teminalContact.terminalId = this.TerminalFormGroup.controls['terminalId'].value;
    teminalContact.merchantNumber = this.TerminalFormGroup.controls['merchantId'].value;
    teminalContact.nameSurname = this.TerminalFormGroup.controls['contactNameSurnameFC'].value;
    teminalContact.address = (isBulkActive ? deviceContact.address : this.TerminalFormGroup.controls['contactAddressFC'].value);
    teminalContact.region = (isBulkActive ? deviceContact.region : this.TerminalFormGroup.controls['contactRegionFC'].value);
    teminalContact.city = (isBulkActive ? deviceContact.city : this.selectedCity);// this.selectedArea; this.TerminalFormGroup.controls['cityFC'].value;
    teminalContact.postalcode = (isBulkActive ? deviceContact.postalcode : this.TerminalFormGroup.controls['contactPostalServiceCodeFC'].value);
    teminalContact.cell = (isBulkActive ? deviceContact.cell : this.TerminalFormGroup.controls['contactNameCellNrFC'].value);
    teminalContact.email = (isBulkActive ? deviceContact.email : this.TerminalFormGroup.controls['contactEmailAddressFC'].value);
    teminalContact.country = (isBulkActive ? deviceContact.country : this.TerminalFormGroup.controls["countryFC"].value);
    
    
    return teminalContact;
  }

  async configureTerminalSignUp() {
    var terminal = await this._terminalService.GetTerminalView(this.TerminalFormGroup.controls['terminalId'].value);
    var termCfg = await this._terminalService.GetTaTermCfg(this.TerminalFormGroup.controls['terminalId'].value);
    var termContactLess = await this._terminalService.GetLastContactlessParam(this.TerminalFormGroup.controls['terminalId'].value)
    var terminalId = String(this.TerminalFormGroup.controls['terminalId'].value);

    this.raiseDanger = false;
    var isBulkActive = null;
    if (this.deviceList.length > 0) {
      const firstObject = this.deviceList[0];
      isBulkActive = firstObject.bulkOrder;
      var termId = String(this.TerminalFormGroup.controls['terminalId'].value);
      var findTerm = this.deviceList.find(x => x.terminalId == termId);
      if (findTerm != null) {
        this.raiseDanger = true;
        this.danger = "Terminal has been captured, please select a different terminal Id.";
        return;
      }     
    }

    if (this.TerminalFormGroup.controls['bulkOrder'].value == true) {
      this.TerminalFormGroup.controls['merchantId'].disable();
      this.TerminalFormGroup.controls['contactNameSurnameFC'].disable();
      this.TerminalFormGroup.controls['contactNameCellNrFC'].disable();
      this.TerminalFormGroup.controls['contactEmailAddressFC'].disable();
      this.TerminalFormGroup.controls['contactAddressFC'].disable();
      this.TerminalFormGroup.controls['contactRegionFC'].disable();
      this.TerminalFormGroup.controls['cityFC'].disable();
      this.TerminalFormGroup.controls['contactPostalServiceCodeFC'].disable();
      this.TerminalFormGroup.controls["countryFC"].disable();
    }

    this.tmCardAcceptor = await this._merchantService.GetTmCardAcceptor(this.TerminalFormGroup.controls['merchantId'].value);
    var nameLocation = this.decodeNameLocation(this.tmCardAcceptor.name_location);

    let signUp = {} as AddUpdateTerminalSignUpViewModel;
    signUp.commsProfile = termCfg.commsProfileId;
    signUp.contactless = (termContactLess?.valueOnServer == "1" ? true : false);
    signUp.deviceMake = this.TerminalFormGroup.controls['deviceMake'].value;
    signUp.deviceModel = this.TerminalFormGroup.controls['deviceModel'].value;
    signUp.manualPanEntry = (termCfg.functionVector == 3 ? true : false);
    signUp.productProfile = termCfg.productProfileId;
    signUp.sameAsMerchantAddress = this.TerminalFormGroup.controls['sameAsMerchantAddress'].value;
    signUp.terminalActive = (terminal.termActive == 1 ? true : false);
    signUp.terminalCapabilities = termCfg.capabilityProfileId;
    signUp.terminalId = terminalId;
    signUp.terminalNumber = termCfg.termNr;
    signUp.terminalType = terminal.termType;
    signUp.deliveryMethod = this.TerminalFormGroup.controls['terminaldeliveryFC'].value;
    signUp.merchantNumber = this.TerminalFormGroup.controls['merchantId'].value;
    signUp.bulkOrder = (isBulkActive == null ? this.TerminalFormGroup.controls['bulkOrder'].value : isBulkActive);
    signUp.terminalConfigId = 1;
    signUp.merchantName = nameLocation.shopName;
    return signUp;
  }

  public decodeNameLocation(nameLocation: string): DecodedNameLocation {
    return {
      shopName: nameLocation.substring(0, 23).trim(),
      city: nameLocation.substring(23, 36).trim(),
      region: nameLocation.substring(36, 38).trim(),
      country: nameLocation.substring(38, 40).trim(),
    };
  }

  onScrollToEnd() {
    this.fetchMore();
  }

  onScroll({ end }) {
    if (this.loading || this.areaData.length <= this.areaBuffer.length) {
      return;
    }

    if (end + this.numberOfItemsFromEndBeforeFetchingMore >= this.areaBuffer.length) {
      this.fetchMore();
    }
  }

  private fetchMore() {
    const len = this.areaBuffer.length;
    const more = this.areaData.slice(len, this.bufferSize + len);
    this.loading = true;
    // using timeout here to simulate backend API delay
    setTimeout(() => {
      this.loading = false;
      this.areaBuffer = this.areaBuffer.concat(more);
    }, 200)
  }

  public async onMakeChange(deviceId: number): Promise<void> {
    if (deviceId > 0) {

      this.deviceModelList = (await this._terminalService.GetDeviceModelsByDeviceId(deviceId)).map((x) => {
        return { id: x.id.toString(), text: x.model }
      });

    }
  }

  public GetDeviceMake(id: string) {
    if (parseInt(id) >= 0) {
      const foundItem = this.terminalMakeList.find(item => item.id === parseInt(id));
      return foundItem.make;
    }
    return "";
  }

  public GetDeviceModel(id: any) {
    if (parseInt(id) >= 0) {
      const foundItem = this.terminalModelList.find(item => item.id === parseInt(id));
      return foundItem.model;
    }
    return "";
  }

}
